module.exports = __webpack_public_path__ + "web/img/articles2.b633d884.png";